import { daysUntil, ddayLabel } from '../../domain.ts';
import type { Plan, PrayerNote } from '../../domain.ts';

/** Prayer Book 여러 화면이 함께 쓰는 표기 규칙. 한 곳에만 둡니다 */

export const today = (): string => new Date().toISOString().slice(0, 10);

/** 상태창의 PLAN 알약 — 'Everyday' 또는 '2026.08.04 · D-6' */
export function planLabel(plan: Plan): string {
  if (plan.type === 'EVERYDAY') return 'Everyday';
  return `${plan.date.replace(/-/g, '.')} · ${ddayLabel(plan.date)}`;
}

/**
 * 카드 아래 한 줄 — «영역 · 날짜 · D-day» (화면 C1).
 *
 * 앞에 영역을 붙입니다. 여러 영역이 섞인 목록이라 어디 것인지가 보여야 하고,
 * 걸러낸 뒤에도 지우지 않습니다 — 카드 생김새가 같아야 덜 헷갈립니다.
 *
 * 뒤는 **기도의 날짜**입니다. 수정한 날짜는 적지 않습니다 — 목록에서 무엇을
 * 열지 고를 때 쓰이지 않는 정보라, 그 한 줄을 기도의 날짜에 온전히 내줍니다.
 *
 * 두 가지가 날짜 자리를 대신합니다.
 *   Everyday    D-day 를 계산하지 않는 노트라 「영역 · Everyday」로 적습니다.
 *               오른쪽 위는 중요도 전용으로 남겨 둡니다
 *   지난 날짜   D-day 없이 날짜만 적습니다. D+12 는 셈이 맞아도 읽을 사람이
 *               없습니다 — 이미 지났다는 것은 날짜가 말하고 있습니다
 */
export function cardMeta(note: PrayerNote): string {
  if (note.plan.type === 'EVERYDAY') return `${note.category} · Everyday`;

  const date = note.plan.date.replaceAll('-', '.');
  if (daysUntil(note.plan.date) < 0) return `${note.category} · ${date}`;
  return `${note.category} · ${date} · ${ddayLabel(note.plan.date)}`;
}

/** 진행 기록의 '예정' 표시 — 오늘보다 뒤면 아직 오지 않은 일입니다 */
export const isFuture = (date: string): boolean => daysUntil(date) > 0;
